/* eslint-disable react/no-danger */
import React from 'react';
import Slider from 'react-slick';

import {localizedMessage} from '../message/Message';
import PropTypes, {string} from 'prop-types';
import BonusSectionStyled from './BonusSectionStyled';

export interface Props {
  show: boolean;
  bonusOffers: any;
  header: string;
  subtitle: string;
  notice: string;
}

const prevArrow = (
  <div className="prev-arrow">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38 38">
      <path d="M.053 19C.053 8.536 8.536.053 19 .053c8.715 0 16.055 5.883 18.266 13.894l-20.792 1.895 6-5.684-5.053-5.053L4.79 18.368 17.42 32.895l5.053-5.053-6-6 21.156.632C35.998 31.279 28.278 37.947 19 37.947 8.536 37.947.053 29.464.053 19z" />
    </svg>
  </div>
);
const nextArrow = (
  <div className="next-arrow">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38 38">
      <path d="M37.947 19C37.947 8.536 29.464.053 19 .053 10.285.053 2.945 5.936.734 13.947l20.792 1.895-6-5.684 5.053-5.053L33.21 18.368 20.58 32.895l-5.053-5.053 6-6-21.156.632C2.002 31.279 9.722 37.947 19 37.947c10.464 0 18.947-8.483 18.947-18.947z" />
    </svg>
  </div>
);

const sliderSetting = {
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: false,
  prevArrow,
  nextArrow,
};

const getImage = (keyImages) => {
  const image = keyImages ? keyImages.find((image) => image.type === 'Thumbnail') : null;
  return image
    ? image.url
    : 'https://cdn2-unrealengine-1251447533.file.myqcloud.com/fn-nav-logo-3e6bd67b98b0.svg';
};

const BonusSection = ({show, bonusOffers, header, subtitle, notice}) => {
  if (!show || !bonusOffers) return null;
  sliderSetting.infinite = bonusOffers.length > 1;
  const slideBox = (
    <Slider {...sliderSetting}>
      {bonusOffers.map((offer) => {
        const {title, keyImages, id} = offer;
        const imageUrl = getImage(keyImages);
        return (
          <div className="bonus-slider-box" key={id}>
            <img src={imageUrl} className="bonus-item-img" alt={title} />
            <h5 className="bonus-item-title">{title}</h5>
          </div>
        );
      })}
    </Slider>
  );
  return (
    <BonusSectionStyled className="ecrp-bonus-wrapper">
      <div className="ecrp-bonus-content">
        <h2>{localizedMessage(header)}</h2>
        {subtitle && <h4>{localizedMessage(subtitle)}</h4>}
        {slideBox}
        <div className="ecrp-bonus-notice">
          <h5>{localizedMessage(notice)}</h5>
        </div>
      </div>
    </BonusSectionStyled>
  );
};

BonusSection.propTypes = {
  bonusOffers: PropTypes.array,
  show: PropTypes.bool,
  header: string,
  subtitle: string,
  notice: string,
};

export default BonusSection;
